import React, { useEffect, useState } from 'react';
import API from '../../services/api';
import './PromotionBanner.css';
import { t } from "@lingui/macro";
import { getLocalizedField } from "../../i18n/backendTranslations";

const PromotionBanner = () => {
  const [currentPromotions, setCurrentPromotions] = useState([]);
  const [selectedPromotion, setSelectedPromotion] = useState(null);

  useEffect(() => {
    fetchCurrentPromotions();
  }, []);

  const fetchCurrentPromotions = async () => {
    try {
      const response = await API.get('/api/promotions/public/current-display');
      if (Array.isArray(response.data)) {
        setCurrentPromotions(response.data);
      } else {
        console.error('Expected an array of promotions, but got:', response.data);
      }
    } catch (error) {
      console.error('Error fetching current promotions:', error);
    }
  };

  const handlePromotionClick = (promotion) => {
    setSelectedPromotion(promotion);
  };

  const handleCloseModal = () => {
    setSelectedPromotion(null);
  };

  return (
    <div className="promotion-banner">
      <h2>{t`Current Promotions`}</h2>

      <div className="promotion-details">
        {currentPromotions.map(promotion => (
          <div 
            key={promotion.id} 
            className="promotion-item" 
            onClick={() => handlePromotionClick(promotion)}
          >
            <p className="promotion-date-range">
              <strong>{new Date(promotion.startDate).toLocaleDateString()}</strong>
              <span className="date-separator"> — </span>
              <strong>{new Date(promotion.endDate).toLocaleDateString()}</strong>
            </p>

            <p className="promotion-description">
              {getLocalizedField(promotion, "description")}
            </p>

            {promotion.imagePath && (
              <img
                src={`${process.env.REACT_APP_BACKEND_URL}${promotion.imagePath}`}
                alt={t`Promotion`}
              />
            )}
          </div>
        ))}
      </div>

      {selectedPromotion && (
        <div className="promotion-item-modal">
          <div className="promotion-item-modal-content">
            <button 
              className="promotion-item-modal-close" 
              onClick={handleCloseModal}
              aria-label={t`Close`}
            >
              &times;
            </button>

            <h2>{t`Promotion Details`}</h2>

            <p className="promotion-date-range">
              <strong>{new Date(selectedPromotion.startDate).toLocaleDateString()}</strong>
              <span className="date-separator"> — </span>
              <strong>{new Date(selectedPromotion.endDate).toLocaleDateString()}</strong>
            </p>

            <p className="promotion-description">
              {getLocalizedField(selectedPromotion, "description")}
            </p>

            {selectedPromotion.imagePath && (
              <img 
                src={`${process.env.REACT_APP_BACKEND_URL}${selectedPromotion.imagePath}`} 
                alt={t`Promotion`} 
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default PromotionBanner;
